// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import DemoRentalHistoryBranchCriteria from './demo-rental-history-branch-criteria';
import DemoRentalHistoryFactoryCriteria from './demo-rental-history-factory-criteria';
import DemoRentalHistoryPinCriteria from './demo-rental-history-pin-criteria';
import DemoRentalHistoryStatusCriteria from './demo-rental-history-status-criteria';
import DemoRentalProductRegCriteria from './demo-rental-product-reg-criteria';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';

const DemoRentalHistoryAttributesCriteria = props =>

    <div className='demo-rental-history-attributes-criteria'>
        <DemoRentalHistoryStatusCriteria
            onStatusChange={props.onStatusChange}
            status={props.status}
            statuses={props.statuses}
        />
        <DemoRentalHistoryPinCriteria
            onPinChange={props.onPinChange}
            pin={props.pin}
        />
        <DemoRentalHistoryBranchCriteria
            branch={props.branch}
            branches={props.branches}
            onBranchChange={props.onBranchChange}
        />
        <DemoRentalHistoryFactoryCriteria
            factory={props.factory}
            factoryCodes={props.factoryCodes}
            onFactoryChange={props.onFactoryChange}
        />
        <DemoRentalProductRegCriteria
            label='PRODUCT_REGISTERED'
            onProductRegistered={props.onProductRegistered}
            productRegistered={props.productRegistered}
        />

    </div>;

DemoRentalHistoryAttributesCriteria.displayName = 'DemoRentalHistoryAttributesCriteria';
DemoRentalHistoryAttributesCriteria.propTypes = {
    branch: PropTypes.string.isRequired,
    branches: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    factory: PropTypes.string.isRequired,
    factoryCodes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    onBranchChange: PropTypes.func.isRequired,
    onFactoryChange: PropTypes.func.isRequired,
    onPinChange: PropTypes.func.isRequired,
    onProductRegistered: PropTypes.func.isRequired,
    onStatusChange: PropTypes.func.isRequired,
    pin: PropTypes.string.isRequired,
    productRegistered: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    statuses: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired

};

export default DemoRentalHistoryAttributesCriteria;




// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/components/demo-rental-history-attributes-criteria.js